import { render, staticRenderFns } from "./ResistantStarch.vue?vue&type=template&id=17f5f40e&scoped=true&"
import script from "./ResistantStarch.vue?vue&type=script&lang=js&"
export * from "./ResistantStarch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f5f40e",
  null
  
)

export default component.exports